// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import Swiper and modules styles


document.addEventListener('DOMContentLoaded', () => {
    const swiper1 = new Swiper(".galerie.swiper", {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 24,
            }
        },
    });

    const swiper2 = new Swiper(".swiperPhilo", {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 20,
        direction: 'horizontal',
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        breakpoints: {
            1200: {
                slidesPerView: '3',
                spaceBetween: 24,
                direction: 'vertical',
            }
        },
    });

    const swiper3 = new Swiper(".swiperRse", {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 20,
        direction: 'horizontal',
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        breakpoints: {
            1200: {
                slidesPerView: '2',
                spaceBetween: 24,
                direction: 'vertical',
            }
        },
    });

    const swiper4 = new Swiper(".swiperGamme", {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 20,
        direction: 'horizontal',
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
    });

/*    window.addEventListener('resize', () => {
        swiper1.update();
        swiper2.update();
        swiper3.update();
        swiper4.update();
    });*/
});

